export default "__VITE_ASSET__h28n8rOa__"